import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';

export const REVIEWS_CONFIRMATION_PAGE_REQUEST = 'REVIEWS_CONFIRMATION_PAGE_REQUEST';
export const REVIEWS_CONFIRMATION_PAGE_SUCCESS = 'REVIEWS_CONFIRMATION_PAGE_SUCCESS';
export const REVIEWS_CONFIRMATION_PAGE_ERROR = 'REVIEWS_CONFIRMATION_PAGE_ERROR';
export const PRODUCT_RATING_SUCCESS = 'PRODUCT_RATING_SUCCESS';
export const PRODUCT_RATING_ERROR = 'PRODUCT_RATING_ERROR';

export function reviewsConfirmationPageRequestAction() {
	return { type: REVIEWS_CONFIRMATION_PAGE_REQUEST };
}

export function reviewsConfirmationSuccessAction(data) {
	return { type: REVIEWS_CONFIRMATION_PAGE_SUCCESS, data };
}

export function reviewsConfirmationErrorAction(error) {
	return { type: REVIEWS_CONFIRMATION_PAGE_ERROR, error };
}

export function fetchReviewsConfirmationPageData(start = 0, count = 5, ugcSource) {
	const requestQuery = {
		start: start,
		count: count
	};
	if (ugcSource) {
		requestQuery.source = ugcSource;
	}
	return dispatch => {
		dispatch(reviewsConfirmationPageRequestAction());
		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/3/reviews/unsolicited',
				query: requestQuery
			})
		).then(
			data => dispatch(reviewsConfirmationSuccessAction(data['RESPONSE'])),
			err => {
				dispatch(reviewsConfirmationErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}

export function productRatingSuccessAction(data) {
	return { type: REVIEWS_CONFIRMATION_PAGE_SUCCESS, data };
}

export function productRatingErrorAction(error) {
	return { type: REVIEWS_CONFIRMATION_PAGE_ERROR, error };
}

export function postProductRatingAction(pid, rating, ugcSource) {
	const finalParams = Object.assign({ productId: pid, rating: rating });
	if (ugcSource) {
		finalParams.source = ugcSource;
	}

	return dispatch => {
		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/3/reviews/product/rate'
			}),
			finalParams
		).then(
			data => dispatch(productRatingSuccessAction(data['RESPONSE'])),
			err => {
				dispatch(productRatingErrorAction(err));
				return Promise.reject(err);
			}
		);
	};
}
